module.exports = __webpack_public_path__ + "static/media/surprised.0ae0ab1f.svg";